import { render, staticRenderFns } from "./infoApp.vue?vue&type=template&id=32ebdb05&scoped=true"
import script from "./infoApp.vue?vue&type=script&lang=js"
export * from "./infoApp.vue?vue&type=script&lang=js"
import style0 from "./infoApp.vue?vue&type=style&index=0&id=32ebdb05&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ebdb05",
  null
  
)

export default component.exports